module.exports = __webpack_public_path__ + "static/img/0000挂缴查.e2b50c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/0000挂缴查.jpg
// module id = Xgis
// module chunks = 0